export default "__VITE_ASSET__Be4Ific6__"